module.exports = __webpack_public_path__ + "media/ג.47d82b3b.mp3";